export default "__VITE_ASSET__CjCJwuEw__"